import type { HelpFile } from '../../types/help'
import { RoleAssignmentsTestIds } from '../../../testids/RoleAssignmentsTestIds'

export const roleAssignmentsHelp: HelpFile = {
  docPage: '/docs/access/role-assignments',
  texts: {
    [RoleAssignmentsTestIds.roleAssignmentsList]:
      'All users and their assigned IAM application roles.',
    [RoleAssignmentsTestIds.colEmail]: null,
    [RoleAssignmentsTestIds.colAssignedRoles]:
      'IAM application roles assigned to this user — controls what they can see and do in the IAM UI.',
  },
}
